import { useCallback, useEffect, useState } from 'react';
import { api } from '../lib/api';

async function fetchList() {
  try {
    const { data } = await api.get('/games-played');
    return data.games || [];
  } catch (err) {
    console.error('games-played fetch failed', err);
    return [];
  }
}

export function useGamesPlayed() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    const list = await fetchList();
    setItems(list);
  }, []);

  useEffect(() => {
    let active = true;
    fetchList().then((list) => {
      if (active) {
        setItems(list);
        setLoading(false);
      }
    });
    return () => {
      active = false;
    };
  }, []);

  return { items, loading, refetch };
}
